<template>
	<SOSlotModal
		v-if="!pageSetting.loading"
		:modal-id="id"
		:modal-title="!isAntarExtra ? 'Hapus Transaksi' : 'Hapus Tagihan'"
		:no-padding="true"
		@close="close"
	>
		<template v-slot:modal-body>
			<div v-if="!isAntarExtra">
				<div class="bg-yellow p-x-20 p-y-8 d-flex align-items-center border-bottom" id="warning-delete">
					<img src="@/assets/icons/alert-circle-yellow.svg" alt="" class="m-r-12">
					<div class="f-regular f-12 f-c-midgrey">
						Menghapus transaksi akan mengubah pencatatan pendapatan, hutang, atau piutang pada akun terkait
						di laporan keuangan Anda.
					</div>
				</div>
				<div class="modal-body">
					<div class="f-regular f-14 f-c-black m-d-12"
					     v-if="transaksi.rincian_pembayaran.filter(v => ewalet.includes(v.jenis_bayar)).length > 0">
						Anda bisa mengubah akun keuangan untuk pengembalian dana
						<b>
							{{
								jenisPembayaran(transaksi.rincian_pembayaran.filter(v => ewalet.includes(v.jenis_bayar))[0].jenis_bayar)
							}}
						</b>
					</div>

					<div class="frame-pembayaran m-d-20" v-if="transaksi.rincian_pembayaran.length > 0">
						<div class="border-bottom p-x-16 p-y-8"
						     v-for="(pembayaran, i) in transaksi.rincian_pembayaran" :key="i"
						>
							<div class="d-flex-between-center f-regular f-14 f-c-black">
								<div>
									{{ jenisPembayaran(pembayaran.jenis_bayar) }}
									<span class="f-c-midgrey">  •  {{ tipeBayar(pembayaran.tipe_bayar) }}</span>
								</div>
								<div v-if="pembayaran.jenis_bayar === 5">
									{{ pembayaran.jumlah_beli }} {{ pembayaran.satuan }}
								</div>
								<div v-else>
									{{ pembayaran.dibayar | currency }}
								</div>
							</div>
							<div class="f-regular f-14 f-c-midgrey">
								<div v-if="ewalet.includes(pembayaran.jenis_bayar)">
									<div class="d-flex">
										<SODropdownGrouped
											v-if="groupedOption.length > 0"
											:id="'dropdown-transaksi'"
											:items="groupedOption[groupedOption.findIndex(v => v.idbayar === pembayaran.idbayar)].options"
											:title="selectedAkunKeuangan(pembayaran.idbayar)"
											:key-replacer="keyReplacer"
											@update-data="(val) => { groupedOption[groupedOption.findIndex(v => v.idbayar === pembayaran.idbayar)].options = val }"
											@selected-value="(val) => { selectedIdakun[selectedIdakun.findIndex(v => v.idbayar === pembayaran.idbayar)].idakun = val }"
										/>
									</div>

									<div class="container-upload-void" :id="'container-upload-void-' + i" v-if="pembayaran.jenis_bayar === 11">
										<div
											:id="'camera-' + i + '-content'"
											:class="{fullScreen: camera[i] === undefined ? false : camera[i].open || camera[i].fullSize}"
										>
											<SOUploadNota
												ref="uploadVoid"
												label=""
												:id="'camera-' + i"
												:images="uploadVoid[i]"
												:camera-open="camera[i] === undefined ? false : camera[i].open"
												:full-size="camera[i] === undefined ? false : camera[i].fullSize"
												:preview-img="selectedPreview"
												@setCamera="onToggleOpen(i)"
												@setFullSize="onToggleFullSize(i)"
												@setImages="setImages($event, i)"
												@deleteImg="onDeleteImg($event, i)"
												@preview="onSelected($event)"
												@hook:mounted="reloadImage(i)"
											/>
										</div>
									</div>
								</div>
								<div v-else-if="pembayaran.jenis_bayar === 4 || pembayaran.jenis_bayar === 5">
									Saldo {{ jenisPembayaran(pembayaran.jenis_bayar) }} dikembalikan
								</div>
								<div v-else>
									Di-refund dari kas laci
								</div>
							</div>
						</div>
					</div>

					<SOInputRegular
						:title="'Catatan (Opsional)'"
						:placeholder="'Ketik catatan...'"
						:validation="'alphanumeric'"
						v-model="catatan"
					/>
				</div>
			</div>
			<div v-else>
				Menghapus tagihan akan <b>mengubah pencatatan</b> pendapatan, hutang, atau piutang pada akun terkait <b>di
				laporan keuangan</b> Anda. Yakin ingin hapus tagihan ini?
			</div>

		</template>
		<template v-slot:modal-footer>
			<div class="modal-footer">
				<SOButton
					:text="'Hapus'"
					:outline-danger="true"
					:full="true"
					:loading="pageSetting.btn.del.loading"
					:disable="pageSetting.btn.del.disabled"
					@action="!isAntarExtra ? transaksi.detail_transaksi.idpermintaan_hapus !== 0 ? pembatalanTransaksi() : deleteTransaksi() : deleteAntarExtra()"
				/>
			</div>
		</template>
	</SOSlotModal>
</template>

<script>
import {mapGetters} from "vuex";
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOInputRegular from "@/so-components/global/input/SOInputRegular";
import SODropdownGrouped from "@/so-components/global/ui/SODropdownGrouped";
import SOUploadNota from "@/so-components/global/ui/SOUploadNota";
import SOButton from "@/so-components/global/ui/SOButton";

export default {
	name: "TransaksiModalHapus",
	props: {
		transaksi: Object,
		isAntarExtra: Boolean,
	},
	components: {
		SOSlotModal,
		SOInputRegular,
		SODropdownGrouped,
		SOUploadNota,
		SOButton
	},
	computed: {
		...mapGetters("metaModule", {
			akunKeuangan: "getAkunKeuangan",
		}),
	},
	data() {
		return {
			id: "modal-hapus-transaksi",
			// camera: {
			// 	open: false,
			// 	fullSize: false,
			// },
			camera: [],
			uploadVoid: [],
			selectedPreview: null,

			pageSetting: {
				loading: true,
				btn: {
					del: {
						disabled: false,
						loading: false,
					}
				}
			},
			catatan: "",
			ewalet: [3, 6, 10, 11],
			groupedOption: [],
			selectedIdakun: [],
			keyReplacer: {
				"1.01.000": "Kas",
				"1.02.000": "Bank",
				"1.13.000": "Void EDC"
			}
		}
	},
	async mounted() {
		// if (this.transaksi.rincian_pembayaran.filter(v => this.ewalet.includes(v.jenis_bayar)).length > 0) {
		await this.getAkunKeuangan()
		// }
		$("#" + this.id).modal("show");

		if (this.transaksi.rincian_pembayaran.length > 0) {
			this.transaksi.rincian_pembayaran.forEach(v => {
				this.uploadVoid = [...this.uploadVoid, []]
				this.camera = [...this.camera, {
					open: false,
					fullSize: false,
				}]
			})
		}
	},
	methods: {
		close() {
			$("#" + this.id).modal("hide");
			setTimeout(() => {
				this.$emit("close")
			}, 500)
		},
		tipeBayar(tipe) {
			if (tipe === 1) {
				return "Lunas"
			} else if (tipe === 2) {
				return "DP"
			} else {
				return "Pelunasan"
			}
		},
		async deleteTransaksi() {
			this.pageSetting.btn.del.disabled = true
			this.pageSetting.btn.del.loading = true

			let dataRefund = []
			this.transaksi.rincian_pembayaran.forEach(v => {
				let akunRefund = this.selectedIdakun.filter(vv => vv.idbayar === v.idbayar)
				if (akunRefund.length > 0) {
					dataRefund = [...dataRefund, {
						idpembayaran: v.idbayar.toString(),
						idakun_refund: akunRefund[0].idakun,
						waktu_pembayaran: v.waktu_bayar_raw.replace("T", " ").split("+")[0],
						idoutlet: v.idoutlet,
						nominal: v.nominal,
						idkaryawan: v.idkaryawan
					}]
				}
			})

			let voidData = []
			this.transaksi.rincian_pembayaran.forEach((v, i) => {
				voidData = [...voidData, {
					idbayar: v.idbayar,
					file: this.uploadVoid[i]
				}]
			})

			const res = await this.$store.dispatch("transaksiModule/deleteTransaksiV2", {
				id: this.transaksi.detail_transaksi.idtransaksi,
				keterangan: this.catatan,
				dataRefund: JSON.stringify(dataRefund),
				voidData: voidData,
			})
			this.pageSetting.btn.del.disabled = false
			this.pageSetting.btn.del.loading = false
			if (res.success) {
				this.close()
				this.$toast.success(res.msg)
				await this.$store.commit("transaksiModule/resetListTransaksiKonsumen")
				this.$router.back()
			} else {
				this.close()
				this.$toast.error(res.err)
			}

			this.smartTrackingClick("hapus_transaksi_reguler");

		},
		async pembatalanTransaksi() {
			this.pageSetting.btn.del.disabled = true
			this.pageSetting.btn.del.loading = true

			let dataRefund = []
			this.transaksi.rincian_pembayaran.forEach(v => {
				let akunRefund = this.selectedIdakun.filter(vv => vv.idbayar === v.idbayar)
				if (akunRefund.length > 0) {
					dataRefund = [...dataRefund, {
						idpembayaran: v.idbayar.toString(),
						idakun_refund: akunRefund[0].idakun,
						waktu_pembayaran: v.waktu_bayar_raw.replace("T", " ").split("+")[0],
						idoutlet: v.idoutlet,
						nominal: v.nominal,
						idkaryawan: v.idkaryawan
					}]
				}
			})

			let voidData = []
			this.transaksi.rincian_pembayaran.forEach((v, i) => {
				voidData = [...voidData, {
					idbayar: v.idbayar,
					file: this.uploadVoid[i]
				}]
			})

			const res = await this.$store.dispatch("transaksiModule/setujuiPermintaanHapus", {
				idpermintaan_hapus: this.transaksi.detail_transaksi.idpermintaan_hapus,
				id: this.transaksi.detail_transaksi.idtransaksi,
				keterangan: this.catatan,
				dataRefund: JSON.stringify(dataRefund),
				voidData: voidData,
			})
			this.pageSetting.btn.del.disabled = false
			this.pageSetting.btn.del.loading = false
			if (res.success) {
				this.close()
				this.$toast.success(res.msg)
				await this.$store.commit("transaksiModule/resetListTransaksiKonsumen")
				this.$router.back()
			} else {
				this.$toast.error(res.err)
			}
			this.smartTrackingClick("setuju_hapus_transaksi_reguler");

		},
		async deleteAntarExtra() {
			this.pageSetting.btn.del.disabled = true
			this.pageSetting.btn.del.loading = true
			const res = await this.$store.dispatch("transaksiModule/deletePengantaranExtra", this.transaksi.idextrabayar)
			this.pageSetting.btn.del.disabled = false
			this.pageSetting.btn.del.loading = false
			if (res.success) {
				this.close()
				this.$toast.success(res.msg)
				this.$router.push("/transaksi/reguler/detail/" + this.transaksi.idtransaksi)
			} else {
				this.$toast.error(res.err)
			}
		},
		async getAkunKeuangan() {
			this.pageSetting.loading = true
			const res = await this.$store.dispatch("metaModule/fetchAkunKeuanganIdtransaksi", {
				idoutlet: this.transaksi.detail_transaksi.idoutlet,
				idtransaksi: this.$route.params.idtransaksi,
				type: "transaksi",
			})
			if (!res.success) {
				this.$toast.error(res.err)
				return
			}
			await this.transaksi.rincian_pembayaran.forEach(pembayaran => {
				if (this.ewalet.includes(pembayaran.jenis_bayar)) {
					let resGroup = this.groupingArray(this.akunKeuangan, "idkategori");
					for (let v in resGroup) {
						let replaceData = []
						resGroup[v].forEach(obj => {
							if (obj.idakun.includes("1.13.")) {
								replaceData = [...replaceData, {
									title: obj.nama_akun,
									selected: true,
									value: obj.idakun
								}]
								this.selectedIdakun = [...this.selectedIdakun, {
									idbayar: pembayaran.idbayar,
									idakun: obj.idakun,
								}]
							} else if (obj.idakun.includes("1.01.8")) {
								replaceData = [...replaceData, {
									title: obj.nama_akun,
									selected: this.akunKeuangan.filter(v => v.idakun.includes("1.13.")).length === 0,
									value: obj.idakun
								}]
								if (this.akunKeuangan.filter(v => v.idakun.includes("1.13.")).length === 0) {
									this.selectedIdakun = [...this.selectedIdakun, {
										idbayar: pembayaran.idbayar,
										idakun: obj.idakun,
									}]
								}
							} else {
								replaceData = [...replaceData, {
									title: obj.nama_akun,
									selected: false,
									value: obj.idakun
								}]
							}
						})
						resGroup[v] = replaceData
					}
					this.groupedOption = [...this.groupedOption, {
						idbayar: pembayaran.idbayar,
						options: resGroup
					}]
					this.selectedAkunKeuangan(pembayaran.idbayar)
				}
			})
			this.pageSetting.loading = false
		},
		selectedAkunKeuangan(idbayar) {
			let options = this.groupedOption[this.groupedOption.findIndex(v => v.idbayar === idbayar)]

			for (let key in options.options) {
				let loopGroupedOption = options.options[key]
				for (let i = 0; i < loopGroupedOption.length; i++) {
					if (loopGroupedOption[i].selected) {
						return '<span class="f-regular f-14 f-c-blue" style="margin-top: -4px">Di-refund dari ' + loopGroupedOption[i].title + '<span>'
					}
				}
			}
		},

		modalFullSize(i) {
			$(".modal-content").addClass("vh-100")
			$(".modal-header").hide()
			$("#warning-delete").addClass("hide")
			$(".modal-footer").hide()
			$(".modal-body").addClass("p-0 vh-100")
			$(".container-upload-void").addClass("hide")
			$("#container-upload-void-" + i).removeClass("hide")
		},
		modalRestoreSize(i) {
			$(".modal-content").removeClass("vh-100")
			$(".modal-header").show()
			$("#warning-delete").removeClass("hide")
			$(".modal-footer").show()
			$(".modal-body").removeClass("p-0 vh-100")
			$(".container-upload-void").removeClass("hide")
		},
		onToggleOpen(i) {
			this.camera[i].open = !this.camera[i].open;
			this.camera[i].open ? this.modalFullSize(i) : this.modalRestoreSize(i)
		},
		onToggleFullSize(i) {
			this.camera[i].fullSize = !this.camera[i].fullSize;
			this.camera[i].fullSize ? this.modalFullSize(i) : this.modalRestoreSize(i)
		},
		setImages(data, i) {
			this.uploadVoid[i] = data;
		},
		onDeleteImg(idx, i) {
			this.uploadVoid[i].splice(idx, 1);
		},
		onSelected(idx) {
			this.selectedPreview = idx;
		},
		reloadImage(i) {
			this.$refs.uploadVoid[i].handleImages();
		},
	}
}
</script>

<style scoped>
.frame-pembayaran {
	border-radius: 4px;
	border: 1px solid #C8D0DD;
}

.fullScreen {
	padding-left: 0px;
	padding-right: 0px;
	margin-top: -108px;
	margin-left: -17px;
	position: absolute;
	width: 100%;
	z-index: 200;
	top: 0;
}

.camera {
	width: 110% !important;
}

.modal-body {
	max-height: 300px;
	overflow: scroll;
}
</style>